import axiosInstance from "./AxiosInstance";

export function listSessions() {
  return axiosInstance.get("/profile/sessions");
}

export function revokeSession(session_id) {
  return axiosInstance.post("/profile/sessions/revoke-one", { session_id });
}

export function revokeOtherSessions() {
  return axiosInstance.post("/profile/sessions/revoke-others", {});
}

export function logoutCurrentSession() {
  return axiosInstance.post("/logout-session", {});
}
